import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './Testimonials.css';

const Team: React.FC = () => {
  const { t } = useTranslation();

  // CEO
  const ceo = {
    id: 1,
    image: '/team/mertteam.png',
    nameKey: 'team.members.m1.name',
    roleKey: 'team.members.m1.role',
    expertiseKey: 'team.members.m1.expertise'
  };

  // Yazılım Mühendisi
  const softwareEngineer = {
    id: 6,
    image: '/team/caner.png',
    nameKey: 'team.members.m6.name',
    roleKey: 'team.members.m6.role',
    expertiseKey: 'team.members.m6.expertise'
  };

  // Ekibimiz fotoğrafı
  const teamPhoto = {
    image: '/hakkimizda3.jpeg',
    titleKey: 'team.ourTeam'
  };

  // Modeller
  const models = [
    {
      id: 2,
      image: '/team/dilarayuksekcan.jpeg',
      nameKey: 'team.members.m2.name',
      roleKey: 'team.members.m2.role',
      languages: ['🇹🇷', '🇬🇧'] // Türkçe, İngilizce
    },
    {
      id: 3,
      image: '/team/polinavladyka.jpeg',
      nameKey: 'team.members.m3.name',
      roleKey: 'team.members.m3.role',
      languages: ['🇷🇺', '🇹🇷', '🇬🇧'] // Rusça, Türkçe, İngilizce
    },
    {
      id: 4,
      image: '/team/svenjapatruska.jpeg',
      nameKey: 'team.members.m4.name',
      roleKey: 'team.members.m4.role',
      languages: ['🇷🇺', '🇹🇷', '🇬🇧'] // Rusça, Türkçe, İngilizce
    },
    {
      id: 5,
      image: '/team/veronikakabilya.jpeg',
      nameKey: 'team.members.m5.name',
      roleKey: 'team.members.m5.role',
      languages: ['🇷🇺', '🇹🇷', '🇬🇧'] // Rusça, Türkçe, İngilizce
    }
  ];

  return (
    <section className="team section" id="team">
      <div className="team-bg">
        <div className="team-glow"></div>
      </div>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="section-title">{t('team.title')}</h2>
          <p className="section-subtitle">{t('team.subtitle')}</p>
        </motion.div>

        {/* CEO, Yazılım Mühendisi ve Ekibimiz - Üstte Yan Yana */}
        <motion.div 
          className="ceo-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="baulig-card ceo-card">
            <img src={ceo.image} alt={t(ceo.nameKey)} className="baulig-image" />
            <div className="baulig-overlay"></div>
            <div className="baulig-content">
              <span className="baulig-role">{t(ceo.roleKey)}</span>
              <h3 className="baulig-name">{t(ceo.nameKey)}</h3>
              <p className="baulig-expertise">{t(ceo.expertiseKey)}</p>
            </div>
          </div>

          <div className="baulig-card ceo-card">
            <img src={softwareEngineer.image} alt={t(softwareEngineer.nameKey)} className="baulig-image" />
            <div className="baulig-overlay"></div>
            <div className="baulig-content">
              <span className="baulig-role">{t(softwareEngineer.roleKey)}</span>
              <h3 className="baulig-name">{t(softwareEngineer.nameKey)}</h3>
              <p className="baulig-expertise">{t(softwareEngineer.expertiseKey)}</p>
            </div>
          </div>
          
          <div className="baulig-card team-photo-card">
            <img src={teamPhoto.image} alt={t(teamPhoto.titleKey)} className="baulig-image" />
            <div className="baulig-overlay"></div>
            <div className="baulig-content">
              <h3 className="baulig-name">{t(teamPhoto.titleKey)}</h3>
            </div>
          </div>
        </motion.div>

        {/* Modeller - Altta 4'lü Grid */}
        <motion.div 
          className="models-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {models.map((member, index) => (
            <motion.div 
              key={member.id}
              className="baulig-card model-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <img src={member.image} alt={t(member.nameKey)} className="baulig-image" />
              <div className="baulig-overlay"></div>
              <div className="baulig-content">
                <span className="baulig-role">{t(member.roleKey)}</span>
                <h3 className="baulig-name">{t(member.nameKey)}</h3>
                {member.languages.length > 0 && (
                  <div className="baulig-languages">
                    {member.languages.map((flag, i) => (
                      <span key={i} className="language-flag">{flag}</span>
                    ))}
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Team;
